<template>
  <div name="Backstage">
    <div class="wrapper">
      <navbar></navbar>
      <siderbar></siderbar>
      <contents></contents>
    </div>
  </div>
</template>
<style>
@import "../../assets/backCss/font-awesome/all.min.css";
@import "../../assets/plugins/datatables-bs4/css/dataTables.bootstrap4.css";
@import "../../assets/plugins/toastr/toastr.css";
/* @import "../../assets/backCss/adminlte/adminlte.css"; */
@import "../../assets/backCss/desktop/normalize.css";
@import "../../assets/backCss/desktop/controlpanel.css";
@import "../../assets/backCss/desktop/main.css";
</style>
<script>
import "../../assets/backJs/adminlte.min.js";
import base from "../../api/httpApi/base";
import siderbar from "./sidebar.vue";
import contents from "./Contents.vue";
import navbar from "./navbar.vue";
import { mapGetters } from "vuex";

export default {
  name: "Backstage",
  data() {
    return {};
  },
  beforeCreate() {
    let admin = this.$store.getters.getAdminUser;
    // console.log(admin);

    let permission = this.$store.getters.getPermission;
    // console.log(admin);
    // console.log(permission);
    if (admin == null || permission.Istoken == false) {
      this.$router.push("/login");
    }
  },
  components: {
    contents: contents,
    navbar: navbar,
    siderbar: siderbar,
  },
  computed:{

    
  },
};
</script> 


// WEBPACK FOOTER //
// src/components/AdminManage/Backstage.vue